import { put } from 'core/middlewares/utilities';
import { cart, checkout } from 'core/use-cases';
import { OldHistory } from 'ui/components/History';

import { getters } from './getters';

/**
 * Orchestrate the redirect to confirmation page
 *
 */
export function* confirmation() {
  const {
    current: { code },
  }: getters.Cart = yield getters.getCart();

  yield put(checkout.actions.createOrderFetch.request());

  yield put(cart.actions.cartCleanUp());
  yield put(checkout.actions.checkoutCleanUp());

  OldHistory.navigate(`/confirmation/${code}`);
}
